import React, { useEffect, useRef, useState } from 'react';
import { Send, Radio } from 'lucide-react';

function Avatar({ name, self }) {
  return (
    <span className="h-7 w-7 rounded-full grid place-items-center text-xs font-600 text-white flex-shrink-0"
      style={{ background: self ? 'linear-gradient(135deg,#D90035,#7A18FF)' : 'linear-gradient(135deg,#2a2140,#151119)', border: '1px solid rgba(255,255,255,0.12)' }}>
      {name[0]}
    </span>
  );
}

export default function CrewChat({ label = 'CREW CHAT — REAL PLAYERS', seed = [], selfName = 'Yordy', className = '' }) {
  const [messages, setMessages] = useState(seed);
  const [text, setText] = useState('');
  const endRef = useRef(null);

  useEffect(() => { endRef.current?.scrollIntoView({ behavior: 'smooth' }); }, [messages]);

  const send = (e) => {
    e.preventDefault();
    const t = text.trim();
    if (!t) return;
    setMessages((m) => [...m, { id: Date.now(), user: selfName, text: t, self: true }]);
    setText('');
  };

  return (
    <div className={`flex flex-col rounded-2xl xc-glass border border-[#B026FF]/20 overflow-hidden ${className}`}>
      <div className="px-4 py-3 border-b border-white/8 flex items-center justify-between">
        <span className="text-xs font-600 tracking-[0.14em] text-white/80">{label}</span>
        <span className="flex items-center gap-1.5 text-[10px] text-[#2FBF71]"><Radio className="h-3 w-3" /> live</span>
      </div>
      <div className="flex-1 overflow-y-auto no-scrollbar p-4 space-y-3 min-h-[240px] max-h-[380px]">
        {messages.map((m) => (
          <div key={m.id} className={`flex items-start gap-2.5 ${m.self ? 'flex-row-reverse' : ''}`}>
            <Avatar name={m.user} self={m.self} />
            <div className={`max-w-[75%] ${m.self ? 'items-end text-right' : ''}`}>
              <div className="text-[11px] text-white/40 mb-0.5">{m.user}</div>
              <div className={`inline-block rounded-2xl px-3.5 py-2 text-sm ${m.self ? 'bg-[#7A18FF]/25 border border-[#B026FF]/30 text-white' : 'bg-white/[0.05] border border-white/10 text-white/85'}`}>{m.text}</div>
            </div>
          </div>
        ))}
        <div ref={endRef} />
      </div>
      <form onSubmit={send} className="p-3 border-t border-white/8 flex items-center gap-2">
        <input value={text} onChange={(e) => setText(e.target.value)} placeholder="Message your crew..."
          className="flex-1 bg-white/[0.04] border border-white/10 rounded-lg px-3.5 py-2.5 text-sm text-white placeholder:text-white/35 focus:border-[#B026FF]/50 outline-none transition-colors" />
        <button type="submit" className="btn-neon rounded-lg h-10 w-10 grid place-items-center flex-shrink-0"><Send className="h-4 w-4" /></button>
      </form>
    </div>
  );
}
